module.exports = __webpack_public_path__ + "static/media/netflix.b2945a16.png";